import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1771.73096,291.036727 C1675.70911,193.659271 1547.94356,140 1411.81846,140 L1411.70549,140 C1275.5804,140 1147.92781,193.659271 1052.1319,290.92376 C1014.51392,328.993601 983.560995,371.921018 959.837949,418.350408 C936.22787,371.921018 905.274943,328.993601 867.769937,291.036727 C771.86105,193.659271 644.208468,140 507.970403,140 L507.857437,140 C371.845305,140 244.079757,193.659271 148.057903,291.036727 C-49.6341478,491.665917 -49.6341478,818.140219 149.752407,1020.12501 L959.837949,1780.27919 L1771.73096,1018.54348 C1969.42301,818.140219 1969.42301,491.665917 1771.73096,291.036727",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHeartSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconHeartSolid, _Component);

  var _super = _createSuper(IconHeartSolid);

  function IconHeartSolid() {
    _classCallCheck(this, IconHeartSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconHeartSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHeart",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHeartSolid.displayName = "IconHeartSolid";
  return IconHeartSolid;
}(Component);

IconHeartSolid.glyphName = 'heart';
IconHeartSolid.variant = 'Solid';
IconHeartSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHeartSolid;
export { IconHeartSolid };